export const STAFF_INGEST_FILES_QUERY_KEY = 'staffIngestFiles';
export const STAFF_INGEST_ROWS_QUERY_KEY = 'staffIngestRows';
